<template>
  <div v-if="notEmpty(shoppingcart) && shoppingcart">
    <div class="darkbg" @click="closeWin('')"></div>
    <div class="box cart-panel">
      <div
        class="block"
        style="background: #4f6f52; border-bottom-left-radius: 0px; border-bottom-right-radius: 0px"
      >
        <div class="row" style="flex-direction: row; height: 50px">
          <div class="left_c title childcenter" style="justify-content: left; width: 90%">
            <span style="font-size: 17px; color: white; padding-left: 5px"> Cart </span>
          </div>
          <div class="right_c title childcenter" style="width: 10%" @click="closeWin()">
            <img
              src="/images/close.png"
              style="margin-right: 5px; width: 19px; height: 19px; object-fit: cover"
            />
          </div>
        </div>
      </div>

      <div class="shoppingcart">
        <div class="mod1 dsc">
          <div class="destop">
            To keep your booking smooth, please check out one tour at a time.
Prices may change with demand—book now before they go up!</div>
        </div>
        <div v-for="(item, index) in shoppingcart" :key="index">
          <div :class="'mod1' + (item.type > 1 ? ' dark' : '')">
            <div class="carttile">              
              <span class="two-line-ellipsis">{{ item.name }}</span>
            </div>
            <div class="cart-item">
              <div class="elm">
                <el-image class="elmimg" v-if="item.img" :src="item.img" />
                <img v-else src="/images/vplOao.png" />
              </div>
              <div class="detail">
                <div class="elm elmtxt departure">
                  <div>
                    Departure Date: <span>{{ flyWeekMDate(item.depart_date) }}</span>
                  </div>
                  <div>
                    Travelers: <span>{{ item.travelers }}</span>
                  </div>
                </div>
                <div v-if="!ismobile" class="checkout">                  
                  <div class="elm elmtxt">
                    <span class="del" @click="cartClear(index, item.id)">
                      <img src="/images/del.png" />
                    </span>
                  </div>
                  <div class="elm elmtxt">
                    <a @click="checkout(item)" v-if="5!=item.type">
                      <span class="elmbtn">{{
                         cartTypes?.btn?.[item.type]??''
                      }}</span>
                    </a>
                  </div>
                  <div class="elm elmtxt">
                    <span class="desktop_h3" v-if="1 == item.type">{{ item.total }}</span>
                  </div>
                  <div v-if="item.type > 1" class="carttype">
                    <img src="/images/icon-9.png" class="ico" alt="" />
                    {{ cartTypes?.title?.[item.type]??'' }}                
                  </div>                  
                </div>
              </div>
            </div>
            <div class="cart-item" v-if="ismobile" >              
              <div class="detail">                
                <div class="checkout">                  
                  <div class="elm elmtxt">
                    <span class="del" @click="cartClear(index, item.id)">
                      <img src="/images/del.png" />
                    </span>
                  </div>
                  <div class="elm elmtxt">
                    <a @click="checkout(item)" v-if="5!=item.type">
                      <span class="elmbtn">{{
                        cartTypes?.btn?.[item.type]??''
                      }}</span>
                    </a>
                  </div>
                  <div class="elm elmtxt">
                    <span class="desktop_h3" v-if="1 == item.type">{{ item.total }}</span>
                  </div>
                  <div v-if="item.type > 1" class="carttype">
                    <img src="/images/icon-9.png" class="ico" alt="" />
                    {{  cartTypes?.title?.[item.type]??'' }}
                  </div>                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useCartStore } from '@/stores/CartStore'
import { useOrderStore } from '@/stores/OrderStore'
import { useUserStore } from '@/stores/UserStore'
import { useCurrencyStore } from '@/stores/CurrencyStore'
import { getCurrentInstance } from 'vue'
import Request from '@/services/Request'
import { formatAmount, notEmpty, formatDateLocal, decodeHTMLEntities } from '@/utils/tool.js'
import { localDriver } from '@/utils/localDriver'
import { getRequiredMembershipTag, isMembershipInsufficient } from '@/utils/membership'

export default {
  data() {
    return {
      formatDateLocal,
      decodeHTMLEntities,
      formatAmount,
      notEmpty,
      order_data: {
        trip_thumb: '',
        product_name: '',
        return_date: '',
        depart_date: '',
        roomlist: [],
        travelers: 1,
        trip_price: 0,
        flight_id: 0,
        cartback: {}
      },
      cartback: {},
      has_data: false,
      cartid: 0,
      token: '',
      shoppingcart: [],
      ismobile:false,
      cartTypes:{
        title:{0:'',1:'Checkout',2:'Price Changed',3:'Sold out',4:'Sold out',5:'Unavailable',6:'Upgrade Needed',7:'Membership Expired'},
        btn:{0:'',1:'Checkout',2:'Update',3:'Select another date',4:'Select another date',5:'Select another date',6:'Upgrade & Book',7:'Renew & Book'}
      }
    }
  },
  setup() {
    const cart = useCartStore()
    const orderStore = useOrderStore()
    const userStore = useUserStore()
    const useCurrency = useCurrencyStore()
    return {
      cart: cart,
      orderStore,
      userStore,
      useCurrency,
    }
  },
  mounted() {
    //  const instance = getCurrentInstance()
    // this.setRef(instance.proxy)
    this.ismobile = (document.documentElement.clientWidth < 750); 
  },
  async created() {
    const customer_id = await localDriver.getItem('customer_id')
    if (customer_id) {
      this.initcart(2)
    }
  },
  methods: {
    async initcart(t) {
      new Request().webPost(
        {},
        async (res) => {
          this.shoppingcart = res.data

          // Fix cart membership validation status (bidirectional check)
          if (this.shoppingcart && this.shoppingcart.length > 0) {
            const userMemberType = parseInt(this.userStore.user?.memberType ?? 0)

            for (let item of this.shoppingcart) {
              if (item.product_id && 'membership_tags' in item) {
                // Check product's membership tag requirements
                const tripMemberNeed = getRequiredMembershipTag(item.membership_tags)?.membershiptype_id ?? 0

                // Apply validation logic
                if (item.type === 7 && tripMemberNeed === 0) {
                  item.type = 1
                }
                if (item.type === 1 && isMembershipInsufficient(userMemberType, tripMemberNeed)) {
                  item.type = 7
                }
              }
            }
          }
        },
        'common/header/carts'
      )
    },
    async checkout(t) {
      sessionStorage.setItem('fp',1);
      if (4 == t.type || 5==t.type) {
        window.location = '/'
      }else if ((t.type%5) > 1 && t.type!=2) {
        window.location = 'details?id=' + t.product_id + '&tk=' + t.token
      } else {        
        new Request().webPost(
          { cRefresh: 1, token: t.token }, //{cRefresh:1,token: new URLSearchParams(window.location.search).get('tk')}
          async (res) => {
            let count = 0
            let travelers = 0
            this.order_data = {
              trip_thumb: '',
              product_name: '',
              return_date: '',
              depart_date: '',
              roomlist: [],
              travelers: 1,
              trip_price: 0,
              flight_id: 0,
              cartback: {}
            }
            this.has_data = false
            this.cartid = 0
            if (res.cart.hasOwnProperty('cartback') && res.cart.cartback.order_data) {
              this.has_data = true
              let order_data = res.cart.cartback.order_data
              if(order_data.currency != this.useCurrency.currentCurrency){
                this.useCurrency.lockCurrency(false)      
                this.useCurrency.setCurrency(order_data.currency)
                this.useCurrency.lockCurrency(true)
              }
              this.cartback = res.cart.cartback
              this.cartid = res.cart.id
              this.token = res.cart.cartback.token
              await localDriver.setItem('cmkey_' + this.token, res.cart.cartback.customer_id)
              if (order_data.hasOwnProperty('trip_thumb'))
                this.order_data.trip_thumb = order_data.trip_thumb
              if (order_data.hasOwnProperty('depart_date'))
                this.order_data.depart_date = order_data.depart_date
              if (order_data.hasOwnProperty('isFlight'))
                this.order_data.flight_id = order_data.isFlight * 1
              else this.order_data.flight_id = 0
              if (res.cart.cartback.hasOwnProperty('roomlist')) {
                res.cart.cartback.roomlist.forEach((room) => {
                  travelers += room.Adults * 1
                  travelers += room.Child * 1
                })
              }
              this.order_data.travelers = travelers
              this.order_data.product_name = res.cart.name
              // this.order_data.trip_thumb = res.cart.products[0].thumb
              if (res.cart.hasOwnProperty('totals')) {
                for (let i in res.cart.totals) {
                  if (res.cart.totals[i].title == 'Total') {
                    this.order_data.trip_price = res.cart.totals[i].text
                    break
                  }
                }
                ////console.log(formatAmount(trip_price)*1);
              }
            }
            if (6==t.type) {
              window.location = 'details?id=' + t.product_id + '&tk=' + t.token              
            }
            else if (2==t.type) {
               window.location = 'details?id=' + t.product_id + '&tk=' + t.token+'&cart=1'
            }
            else{
              await this.checkout1(t)
            }
          },
          'common/header/getHeaderData',
          (err) => {},
          5000,
          3
        )
      }
    },

    closeWin() {
      this.$emit('closeCart') // 当点击关闭按钮时，触发close事件
    },
    async cancel() {
      if (confirm('Are you sure to delete it?')) {
        await localDriver.removeItem('product_info')
        await localDriver.removeItem(this.odkey)
        this.product_info = this.default_product_info
      }
    },
    cartClear(idx, id) {
      let cartReq = { id }
      new Request().webPost(
        cartReq,
        (res) => {
          if (res.success) {
            this.shoppingcart.splice(idx, 1)
            this.cart.setCount(parseInt(this.cart.getCount() * 1.0) - 1)
            this.initcart(1)
          } else {
            console.log(res.msg)
          }
        },
        'checkout/cart/remove'
      )
    },
    async checkout1(item) {
      if (notEmpty(this.cartback)) {
        this.orderStore.setToken(this.cartback.token)
        this.token = this.orderStore.token
        await localDriver.removeItem('travelers_'+this.orderStore.token)  
        await localDriver.setItem(
          'roomlist_' + this.cartback.token,
          this.cartback.roomlist
        )  
        await localDriver.setItem(
          'order_data_' + this.cartback.token,
          this.cartback.order_data
        )
        //await this.useCurrency.setCurrency(this.cartback.order_data.pageCurrency)
        await localDriver.setItem(
          'orderPrices_' + this.cartback.token,
          this.cartback.orderPrices
        )
        await localDriver.setItem('time_'+this.token,new Date().getTime())
        let toUrl =  (this.cartback.order_data.isFlight == 0 ? '/booking' : '/flight') +
          '?tk=' +
          this.cartback.token 
        window.location.href  = toUrl
      }
      return false
    },
    flyWeekMDate(d, y = 1, w=1) {
      var dt = new Date((notEmpty(d) ? d.slice(0, 10) : d) + 'T00:00:01')
      var weeks = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      var months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ]
      var formattedDate =( (1==w)?(weeks[dt.getDay()] +', '):'' ) +
        months[dt.getMonth()] +
        ' ' +
        dt.getDate() +
        ',' +
        (y > 0 ? ' ' + dt.getFullYear() : '')
      return formattedDate
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  position: fixed;
  bottom: 35px;
  /* Changed bottom margin to 50px */
  right: 25px;
  transform: translate(0%, 0%);
  /* Removed vertical centering offset */
  background-color: white;
  width: 621px;
  height: auto;
  /* Changed height to 500px */
  max-height: 95%;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(18, 23, 70, 0.08);
  border-radius: 8px;
  opacity: 1;
  border-radius: 12px;
  z-index: 99999999;
  background: #fff;
  font-size: 1.7333rem;
  overflow-y: auto;

  .mod1 {
    background: #f5f5f5;
    border-radius: 15px;
    margin: 15px;
    padding: 0px;

    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      /*  border-bottom: 1px solid #d8d8d8; */
      padding-bottom: 16px;
      padding: 10px;
      padding-top: 10px;
      margin-top: 15px;

      img {
        width: 100%;
        border-radius: 6px;
      }

      .info {
        width: 100%;

        .name {
          font-size: 17px;
          text-align: left;
          font-weight: bold;
          color: #333333;
          padding: 9px;
          padding-left: 0px;
          line-height: 25px;
          width: 100%;
        }

        .details {
          margin-top: 21px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 10px 0px;
          padding-bottom: 1rem;

          .d-con {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            margin: 8px;
            background: #fff;
            border-radius: 10px;
            padding: 11px;

            .d-con-t {
              font-size: 1.4083rem;

              font-weight: 400;
              color: #a0a0a0;
            }

            .d-con-d {
              margin-top: 8px;
              font-size: 1.4083rem;

              font-weight: 400;
              color: #071525;
            }
          }
        }
      }

      .info2 {
        margin-left: auto;
        margin-right: 8px;

        .price {
          font-size: 1.4083rem;

          font-weight: 400;
          color: #071525;
          text-align: right;
        }

        .btns {
          margin-top: 18px;
          display: flex;
          align-items: center;

          .btn1 {
            width: 50px;
            height: 22px;

            background: #a6a6a6;
            border-radius: 14px;
            font-size: 1.4083rem;

            font-weight: bold;
            color: #ffffff;
            text-align: center;
            line-height: 22px;
            margin-right: 13px;
          }

          .btn2 {
            width: 50px;
            height: 22px;
            background: #4ca771;
            border-radius: 14px;
            font-size: 1.4083rem;

            font-weight: bold;
            color: #ffffff;
            text-align: center;
            line-height: 22px;
          }
        }
      }
    }
    .carttile {
      margin: 15px 5px 5px 10px;
      padding: 15px 3px 0px 3px;
      color: #333333;
      font-family: Poppins;
      font-weight: 600;
      font-size: 14px;
      line-height: normal;
      letter-spacing: 0%;
      display: flex;
      flex-direction: column;

      .two-line-ellipsis {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; 
        overflow: hidden;
        text-overflow: ellipsis;
      }
      
      
    }
    .cart-item {
      padding: 0.5rem;
      display: flex;
      justify-content: flex-start;
      .detail {
        display: flex;
        flex-direction: column;
        width: 100%;

        .checkout {          
          div{
            float:right;
          }
          //width: 55%;

          .carttype { 
            display: flex;
            align-items: center;
            gap: 4px; 

            margin-top:1.1rem;           
            height: 18px;
            font-family: Poppins;
            font-weight: 700;
            font-size: 12px;
            line-height: 100%;
            letter-spacing: 0%;

            color: var(--Text-warning, #f92d2d);

            img {
              width: 1.2em;
              height: 1.2em;
              top: 15px;
              left: 9.06px;
              border-radius: 0;
              
              color: var(--Text-warning, #f92d2d);

              margin-right: 0.5rem;
            }
          }
        }
      }
      .elm {
        margin: 3px;
        padding: 1px;

        :deep img {          
          width: 85px;
          height: 73px;
          border-radius: 8px;
          gap:10px;
          padding: 1px;
        }
      }
      .elmtxt {
        margin-top: 5px;
        font-family: Poppins;
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: 0%;
        text-transform: capitalize;
        color: #333333;

        .title {
          float: right;
          width: 20%;

          img {
            margin-right: 5px;
            width: 19px;
            height: 19px;
            object-fit: cover;
          }
        }
        a {
          text-decoration: none;
          margin-right: 5px;
          float: right;
        }
        .desktop_h3 {
          font-family: Poppins;
          font-weight: 600;
          font-size: 14px;
          line-height: 100%;
          letter-spacing: 0%;
        }
        .elmbtn {
          color: black;
          background: #00f1bd;
          height: 34px;
          border-radius: 8px;
          gap: 10px;                                                          
          padding: 1.2rem 1.5rem;
          font-family: Poppins;
          font-weight: 600;
          font-size: 12px;
          line-height: 100%;
          letter-spacing:normal;
          vertical-align: middle;
        }
      }
    }
  }

  .shoppingcart {
    width: 621px;
    max-height: 608px;
    top: 472px;
    left: 8189px;
    border-radius: 20px;
    border-width: 1px;
    padding-bottom: 20px;
    gap: Desktop/m4-20;
  }

  .dsc {
    background: #fff;
    .destop {
      font-family: Poppins;
      font-weight: 400;
      font-size: 14px;
      line-height: 100%;
      letter-spacing: 0%;
      padding: 5px;
      color: #333333;
      line-height: normal;
    }
  }

  .dark {
    color: #999999;
    .carttile {
      color: inherit;
    }

    .cart-item {
      .elmtxt {
        color: inherit;
      }
    }
  }
  .head {
    display: flex;
    align-items: center;

    .title {
      font-size: 1.4083rem;

      font-weight: bold;
      color: #333333;
    }

    .cz {
      display: flex;
      align-items: center;
      margin-left: auto;

      .active {
        color: #4ca771 !important;
      }

      .btn {
        margin-left: 20px;
        font-size: 1.4083rem;

        font-weight: 400;
        color: #333333;
      }
    }
  }
}

.detail .checkout .del img {
  width: 2rem !important;
  height: 2rem !important;
}
.detail .departure {
  padding-left: 1rem !important;
}

.detail .departure div {
  background: #fff;
  border-radius: 6px;
  margin-right: 0.5rem;
  margin-top: 0.6rem;
  display: inline-block;
  padding: 0 0.8rem;
  font-size: 1.3rem;


}
.detail .departure > div:last-child {
  margin-top: 2rem;
}
.cart-item > div:first-child {
  display: flex;
  align-items: center;
}
/* 移动端  */
@media screen and (max-width: 750px) {
  .box {
    max-height: 90%;
    bottom: 3rem;
    /* Changed bottom margin to 50px */
    right: 1rem;
    transform: translate(0%, 0%);
    /* Removed vertical centering offset */

    width: 35rem;

    .shoppingcart {
      width: 35rem;
      max-height: 50rem;

      .cart-item {

        .detail {
          display: flex;
          flex-direction: column;
          
          padding-left: 0.5rem;

          .checkout{
            .carttype{
              margin-top:0.8rem;
            }
          }
        }
        .elm {
          :deep(img) {
            
            width: 7rem;
            height: 6rem;
          }

          .elmbtn {
            color: black;
            background: #00f1bd;
            height: 34px;
            border-radius: 8px;
            gap: 10px;
            font-weight: 550;
            padding: 0.6rem 1rem;
            margin: 0 0.2rem;
          }
        }
      }
    }
  }

  .detail .checkout .del img {
    width: 1.6rem !important;
    height: 1.6rem !important;
  }
  .detail .departure {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: 0rem !important;

    margin-bottom: 1rem;
  }
  .detail .departure div {
    width: 212px;
    height: 34px;
    border-radius: 10px;
    gap: 4px;
    padding: 6px 5px;
    font-family: Poppins;
    font-weight: 400;
    font-size: 12px;
    letter-spacing: 0%;
  }
  .detail .departure div {
    margin-top: 1rem !important;
     }

  .detail > div:last-child {
    width: 100%;
  }
}
</style>
